import React from 'react';
import tobeor from 'tobeor';
import { shouldShowTrplAsEdited } from '../../../utils';

import TextTrplControl from './TextTrplControl';

const TextTrpls = ({
  rst,
  item,
  trpls,
  type,
  formId,
  classes,
  setTrpl,
  groupId,
  constant,
  isVirtual,
  isNewNode,
  ancestorId,
  tidsChains,
  loadingTids,
  deletedTids,
  hideSetDelete,
  isAnotherNode,
  onRstValueEdit,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  showMandatoryAlert,
  disableTrplEditing,
  resetDeletedTrplId,
  getAutocompleteTrpls,
  onChangeTextereaHeight,
  updateDataOnRestoreTrpl,
}) => {

  const isInteger = tobeor(rst.type, ['INTEGER', 'FLOAT']);

  const notEditable = constant || disableTrplEditing;

  return (
    <div>
      {
        trpls.map((trpl, trplIndex) => {
          let isTrplEdited;
          try {
            isTrplEdited = shouldShowTrplAsEdited(trpl);
          } catch (e) {
            console.error('Error by pressing Enter + Up buttons:', e);
          }

          const showMandatoryField = showMandatoryAlert && !trpl.tid;
          const disabledDefaultField = rst.has_def_val && !trpl.tid && isNewNode;

          const trplInputProps = {
            classes: {
              root: classes.trplTextField,
              input: disabledDefaultField
              ? classes.trplIsDefault : `${classes.trplTextFieldInput} ${isTrplEdited
                ? classes.trplEdited
                : showMandatoryField
                  ? classes.mandatoryField
                  : isVirtual && notEditable
                  ? classes.notEditableVirtualTrpl
                  : isVirtual
                    ? classes.trplVirtual
                    : notEditable && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                    : trpl && trpl.tid
                      ? classes.trplWithValue
                      : classes.trplEmpty
                }`,
            },
            disableunderline: 'true',
          };

          const selectClasses = {
            root: `${disabledDefaultField ? classes.hide : classes.itemSelect} ${classes.trplSelectContainer} ${shouldShowTrplAsEdited(trpl)
              ? classes.trplEdited
              : showMandatoryField
                ? classes.mandatoryField
                : isVirtual && notEditable
                ? classes.notEditableVirtualTrpl
                : isVirtual
                  ? classes.trplVirtual
                  : notEditable && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                  : trpl && trpl.tid
                    ? classes.trplWithValue
                    : classes.trplEmpty
              }`,
          };

          const textAreaClassName = `${classes.trplTextFieldInput}
            ${showMandatoryAlert && !trpl.tid ? classes.mandatoryField : ''}
            ${isTrplEdited
              ? classes.trplEdited
              : isVirtual && notEditable
              ? classes.notEditableVirtualTrpl
              : isVirtual
                ? classes.trplVirtual
                : notEditable && trpl && trpl.tid
                  ? classes.notEditableTrplWithValue
                : trpl && trpl.tid
                  ? classes.trplWithValue
                  : classes.trplEmpty
            }`;

          return (
            <TextTrplControl
              item={item}
              constant={constant}
              ancestorId={ancestorId}
              classes={classes}
              deletedTids={deletedTids}
              hideSetDelete={hideSetDelete}
              selectClasses={selectClasses}
              disableTrplEditing={disableTrplEditing}
              disabledDefaultField={disabledDefaultField}
              getAutocompleteTrpls={getAutocompleteTrpls}
              groupId={groupId}
              isAnotherNode={isAnotherNode}
              isInteger={isInteger}
              isNewNode={isNewNode}
              loadingTids={loadingTids}
              setLoadingTids={setLoadingTids}
              key={`${rst.title}.${rst.id}.${trplIndex}`}
              onRstValueEdit={onRstValueEdit}
              removeTrplValue={removeTrplValue}
              rst={rst}
              setTrpl={setTrpl}
              showMandatoryAlert={showMandatoryAlert}
              textAreaClassName={textAreaClassName}
              trpl={trpl}
              trplIndex={trplIndex}
              trplInputProps={trplInputProps}
              tidsChain={tidsChains && trpl.tid && tidsChains[trpl.tid]}
              type={type}
              onChangeTextereaHeight={onChangeTextereaHeight}
              formId={formId}
              setDeletedTrplId={setDeletedTrplId}
              updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
              resetDeletedTrplId={resetDeletedTrplId}
            />
          );
        })
      }
    </div>
  );
};

export default TextTrpls;
